import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
const initialFieldValues = {
  salaryId: "00000000-0000-0000-0000-000000000000",
  staffId: "00000000-0000-0000-0000-000000000000",
  amount: "",
};
export default function Salary() {
  const [lists, setLists] = useState([]);
  const [values, setValues] = useState(initialFieldValues);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [errors, setErrors] = useState({});
  const [btnSubmit, setBtnSubmit] = useState(true);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [data, setData] = useState([]);
  const [staff, setStaff] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const userId = localStorage.getItem("userId");
  const headerconfig = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("userToken"),
    },
  };
  useEffect(() => {
    if (recordForEdit !== null) {
      setValues(recordForEdit);
    }
  }, [recordForEdit]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };
  const resetForm = () => {
    setValues(initialFieldValues);
    setErrors({});
  };
  const showEditDetails = (data) => {
    setRecordForEdit(data);
  };
  const GetPageData = (number) => {
    if (number >= 1 && number <= totalPages) {
      setPageNumber(number);
      GetData(number);
    }
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }
  const renderPageNumbers = pageNumbers.map((number) => {
    return (
      <li
        className="page-item"
        key={number}
        id={number}
        onClick={() => GetPageData(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    );
  });
  const validate = () => {
    let temp = {};
    temp.staffId =
      values.staffId === "00000000-0000-0000-0000-000000000000" ? false : true;
    temp.amount = values.amount === "" ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnSubmit(false);
      const formData = new FormData();
      formData.append("salaryId", values.salaryId);
      formData.append("staffId", values.staffId);
      formData.append("amount", values.amount);
      addOrEdit(formData);
    }
  };

  const applicationAPI = () => {
    return {
      create: (newRecord) =>
        axios.post(
          config.APIACTIVATEURL + config.CREATESTAFFSALARY,
          newRecord,
          {
            ...headerconfig,
          }
        ),
      update: (updateRecord) =>
        axios.put(
          config.APIACTIVATEURL + config.UPDATESTAFFSALARY,
          updateRecord,
          {
            ...headerconfig,
          }
        ),
    };
  };
  const addOrEdit = (formData) => {
    if (formData.get("salaryId") === "00000000-0000-0000-0000-000000000000") {
      applicationAPI()
        .create(formData)
        .then((res) => {
          if (res.data.statusCode === 200) {
            handleSuccess(res.data.data);
            resetForm();
            GetData(pageNumber);
            setBtnSubmit(true);
          } else {
            handleError(res.data.data);
            setBtnSubmit(true);
          }
        })
        .catch(function (error) {
          handleError("Error in saving data");
          setBtnSubmit(true);
        });
    } else {
      applicationAPI()
        .update(formData)
        .then((res) => {
          if (res.data.statusCode === 200) {
            handleSuccess(res.data.data);
            resetForm();
            GetData(pageNumber);
            setBtnSubmit(true);
          } else {
            handleError(res.data.data);
            setBtnSubmit(true);
          }
        })
        .catch(function (error) {
          handleError("Error in updating data");
          setBtnSubmit(true);
        });
    }
  };

  const onDelete = (e, id) => {
    if (window.confirm("Are you sure to delete this record?")) {
      axios
        .delete(config.APIACTIVATEURL + config.DELETESTAFFSALARY + "/" + id, {
          ...headerconfig,
        })
        .then((response) => {
          if (response.data.statusCode === 200) {
            handleSuccess(response.data.data);
            GetData(pageNumber);
            resetForm();
          } else {
            handleError(response.data.data);
            GetData(pageNumber);
            resetForm();
          }
        });
    }
  };
  const GetData = (number) => {
    axios
      .get(
        config.APIACTIVATEURL +
          config.GETSTAFFSALARY +
          "?userId=" +
          userId +
          "&pageNumber=" +
          number +
          "&pageSize=" +
          pageSize +
          "",
        { ...headerconfig }
      )
      .then((response) => {
        setLists(response.data.data);
        setPageNumber(response.data.data.pageNumber);
        setPageSize(response.data.data.pageSize);
        setTotalPages(response.data.data.totalPages);
        setData(response.data.data);
        setTotalRecords(response.data.data.totalRecords);
      });
  };
  const GetStaff = () => {
    axios
      .get(config.APIACTIVATEURL + config.GETALLSTAFFS + "?userId=" + userId, {
        ...headerconfig,
      })
      .then((response) => {
        setStaff(response.data.data);
      });
  };
  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";
  useEffect(() => {
    GetData(pageNumber);
    GetStaff();
  }, []);
  return (
    <div id="layout-wrapper">
      <LayoutHeader></LayoutHeader>
      <LayoutSideBar></LayoutSideBar>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Salary</h4>
                </div>
              </div>
            </div>
            <div className="alert alert-success">
              <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                <div className="row">
                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label htmlFor="staffs" className="form-label">
                        Staff
                      </label>
                      <select
                        type="text"
                        value={values.staffId}
                        name="staffId"
                        onChange={handleInputChange}
                        className={"form-select" + applyErrorClass("staffId")}
                      >
                        <option value="0">Please select</option>
                        {staff.length > 0 &&
                          staff.map((c) => (
                            <option value={c.staffId}>{c.staffName}</option>
                          ))}
                      </select>
                      {errors.staffId === false ? (
                        <div className="validationerror">Please select</div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label htmlFor="amount" className="form-label">
                        Amount
                      </label>
                      <input
                        type="text"
                        value={values.amount}
                        name="amount"
                        onChange={handleInputChange}
                        className={"form-control" + applyErrorClass("amount")}
                        placeholder="Please Enter Amount"
                      />
                      {errors.amount === false ? (
                        <div className="validationerror">
                          Please enter amount{" "}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                      {btnSubmit === true ? (
                        <button type="submit" className="btn btn-primary w-100">
                          {values.salaryId ===
                          "00000000-0000-0000-0000-000000000000"
                            ? "Submit"
                            : "Update"}
                        </button>
                      ) : (
                        <button
                          type="submit"
                          className="btn btn-primary w-100"
                          disabled
                        >
                          Please wait...
                        </button>
                      )}
                      <button
                        type="button"
                        className="btn btn-danger w-100"
                        onClick={resetForm}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="row">
              <div className="col-xl-12">
                <div className="card card-height-100">
                  <div className="card-body">
                    <div className="table-responsive table-card">
                      <table className="table align-middle" id="customerTable">
                        <thead className="table-light">
                          <tr>
                            <th>S.No</th>
                            <th>Staff </th>
                            <th>Amount</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody className="list form-check-all">
                          {lists.length > 0 &&
                            lists.map((v, index) => (
                              <tr key={v.salaryId}>
                                <td>
                                  {(pageNumber - 1) * pageSize + (index + 1)}
                                </td>
                                <th>{v.staffName}</th>
                                <th>{v.amount}</th>
                                <td>
                                  <ul className="list-inline hstack gap-2 mb-0">
                                    <li
                                      className="list-inline-item"
                                      data-bs-toggle="tooltip"
                                      data-bs-trigger="hover"
                                      data-bs-placement="top"
                                      title="Edit"
                                    >
                                      <Link
                                        className="edit-item-btn"
                                        onClick={() => showEditDetails(v)}
                                      >
                                        <i className="ri-pencil-fill align-bottom text-muted" />
                                      </Link>
                                    </li>
                                    <li
                                      className="list-inline-item"
                                      data-bs-toggle="tooltip"
                                      data-bs-trigger="hover"
                                      data-bs-placement="top"
                                      title="Delete"
                                    >
                                      <Link
                                        className="remove-item-btn"
                                        onClick={(e) => onDelete(e, v.salaryId)}
                                      >
                                        <i className="ri-delete-bin-fill align-bottom text-muted" />
                                      </Link>
                                    </li>
                                  </ul>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                      <div className="flex-shrink-0">
                        <div className="text-muted">
                          Showing{" "}
                          <span className="fw-semibold">{lists.length}</span> of{" "}
                          <span className="fw-semibold">{totalRecords}</span>{" "}
                          Results
                        </div>
                      </div>
                      <ul className="pagination pagination-separated pagination-sm mb-0">
                        <li
                          className={
                            "page-item " + (pageNumber === 1 ? "disabled" : "")
                          }
                          onClick={() => GetPageData(pageNumber - 1)}
                        >
                          <Link className="page-link">Previous</Link>
                        </li>

                        {renderPageNumbers}

                        <li
                          className={
                            "page-item " +
                            (pageNumber === totalPages ? "disabled" : "")
                          }
                          onClick={() => GetPageData(pageNumber + 1)}
                        >
                          <Link className="page-link">Next</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
